import React, { useState } from "react";
import {
  Alert,
  Divider,
  message,
  Modal,
  Space,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import PropTypes from "prop-types";
import { updatePartnerSuperPartnerStatus } from "../../Pages/api";

const { Text } = Typography;

const ManageSuperPartnerModal = ({ visible, onClose, partner, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const isSuperPartner = !!partner?.isReferEarnSuperPartner;

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await updatePartnerSuperPartnerStatus(
        partner._id,
        !isSuperPartner
      );

      if (response?.code === 200 || response?.code === 201) {
        message.success(
          isSuperPartner
            ? "Super Partner tag removed successfully"
            : "Partner marked as Super Partner successfully"
        );
        if (onSuccess) {
          onSuccess();
        }
        onClose();
      } else {
        message.error(
          response?.message || "Failed to update Super Partner status"
        );
      }
    } catch (err) {
      console.error(err);
      message.error(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={isSuperPartner ? "Remove Super Partner" : "Mark as Super Partner"}
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okText={isSuperPartner ? "Remove" : "Mark as Super Partner"}
      cancelText="Cancel"
      confirmLoading={loading}
      okButtonProps={{ danger: isSuperPartner }}
      destroyOnClose
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>
          <Text strong>Partner Details:</Text>
          <div style={{ marginTop: 8 }}>
            <Text>{partner?.name}</Text>
            <br />
            <Text type="secondary">{partner?.email}</Text>
            <br />
            <Text type="secondary">{partner?.phone}</Text>
            <br />
            <Text type="secondary">({partner?.host})</Text>
            <br />
            <Text
              type="secondary"
              style={{ fontSize: 12 }}
              copyable={{ text: partner?._id }}
            >
              Referral ID: {partner?._id}
            </Text>
          </div>
        </div>

        <Divider style={{ margin: "12px 0" }} />

        {/* Current Super Partner status */}
        <div>
          <Text strong>Current Status:</Text>
          <div style={{ marginTop: 8 }}>
            {isSuperPartner ? (
              <Tooltip title="Super Partner">
                <Tag color="gold" style={{ fontSize: 14, padding: "4px 12px" }}>
                  Super
                </Tag>
              </Tooltip>
            ) : (
              <Tooltip title="Not a Super Partner">
                <Tag
                  color="default"
                  style={{ fontSize: 14, padding: "4px 12px" }}
                >
                  Not Super
                </Tag>
              </Tooltip>
            )}
          </div>
        </div>

        <Alert
          message="Note"
          description={
            isSuperPartner
              ? "Removing the Super Partner tag will stop the paid product exception for this partner. The Super tag will no longer show on the partner listings."
              : "Marking this partner as a Super Partner grants them the exception for paid products. Only Refer & Earn enabled creators can be marked."
          }
          type="info"
          showIcon
        />
      </Space>
    </Modal>
  );
};

ManageSuperPartnerModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  partner: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    host: PropTypes.string,
    isReferEarnSuperPartner: PropTypes.bool,
  }),
  onSuccess: PropTypes.func,
};

ManageSuperPartnerModal.defaultProps = {
  partner: null,
  onSuccess: () => {},
};

export default ManageSuperPartnerModal;
